import { Controller } from "@hotwired/stimulus"

const axios = require('axios');

export default class extends Controller {
	static targets = ['form', 'otherAmount'];

	/**
	 * Select amount from dropdown
	 *
	 * @param {Event} e
	 */
	selectAmount(e) {
		e.preventDefault();
		const amount = e.target.value;

		if (amount === 'other') {
			this.otherAmountTarget.classList.remove('hidden');
		} else if (!this.otherAmountTarget.classList.contains('hidden')) {
			this.otherAmountTarget.classList.add('hidden');
		}
	}


}
